/**
 * Created by Florin David on 2019-04-27.
 */
import { NavigateFunction } from 'react-router/dist/lib/hooks'

let navigate: NavigateFunction

export const goTo = (location: string): void => navigate?.(location)

export const setNavigate = (navigateFn: NavigateFunction): void => {
  navigate = navigateFn
}
